import jQuery from 'jquery';
import 'jquery.cookie';
import rpGuiGuide from 'rp-gui-guide';
import { cleanLegacy } from 'rp-cookie';
import rpPopup from 'rp-popup';
import initNavigationPrefs from 'rp-url-navigation-prefs';
import React from 'react';
import ReactDOM from 'react-dom';
import { Provider } from 'react-redux';
/**
 * @NOTE: Have to import something from 'rp-navigation' in order to execute embedded init logic!!!
 */
import { authReady } from 'rp-navigation'; // eslint-disable-line no-unused-vars
import analyticsPage from './analyticsPage';

import configureStore from './configureStore';
import App from './App';

import '../css/main.scss';

jQuery.cookie('to_force_inclusion_in_code');
analyticsPage();
/**
 * Clean-up legacy cookies
 */
cleanLegacy();
/**
 * Initialize gui-guide scripts
 */
rpGuiGuide({
    svg: { polyfill: true },
});
/**
 * Initialize popup component
 */
rpPopup();
/**
 * Initialize navigation cards preferencers
 */
initNavigationPrefs();

const root = document.getElementById('root');

/**
 * Render react application to root element
 */
if (root) {
    ReactDOM.render(
        (<Provider store={configureStore()}>
            <App />
        </Provider>),
        document.getElementById('root'),
    );
}



// WEBPACK FOOTER //
// ./src/js/index.jsx